import { render, staticRenderFns } from "./addNewData.vue?vue&type=template&id=355e33c9&scoped=true"
import script from "./addNewData.vue?vue&type=script&lang=js"
export * from "./addNewData.vue?vue&type=script&lang=js"
import style0 from "./addNewData.vue?vue&type=style&index=0&id=355e33c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355e33c9",
  null
  
)

export default component.exports